import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonDropdown } from '@dossierhq/design';
import { useCallback } from 'react';
import { SchemaEditorActions, } from '../../reducers/SchemaEditorReducer/SchemaEditorReducer.js';
const EMPTY_ID = '  empty  ';
export function NameFieldSelector({ value, potentialNameFields, typeSelector, dispatchSchemaEditorState, }) {
    const items = [
        { id: EMPTY_ID, label: _jsx("i", { children: "Not set" }) },
        ...potentialNameFields.map((name) => ({ id: name, label: name })),
    ];
    const handleItemClick = useCallback((item) => dispatchSchemaEditorState(new SchemaEditorActions.ChangeTypeNameField(typeSelector, item.id === EMPTY_ID ? null : item.id)), [dispatchSchemaEditorState, typeSelector]);
    return (_jsx(ButtonDropdown, { items: items, renderItem: (item) => item.label, activeItemIds: [value ? value : EMPTY_ID], onItemClick: handleItemClick, children: value ?? _jsx("i", { children: "Not set" }) }));
}
//# sourceMappingURL=NameFieldSelector.js.map